import {ProductWebSiteURLs} from '../../../js/constants'

export const ICalTabType = {
    ALL_FEEDS: 'allFeeds',
    USER_FEEDS: 'userFeeds',
}

export const LEARN_MORE_URL = ProductWebSiteURLs.USER_GUIDE_URL + 'calendars.html#ical'

export const SortingProperty = {
    FEED_NAME: 'BY_FEED_NAME',
    CREATOR_NAME: 'BY_CREATOR_NAME',
    EDITOR_NAME: 'BY_EDITOR_NAME',
    CREATED_DATE: 'BY_CREATED_DATE',
    EDITED_DATE: 'BY_EDITED_DATE',
    LAST_SYNC: 'BY_LAST_SYNC',
}

export const DEFAULT_SORTING = {
    property: SortingProperty.FEED_NAME,
    isAsc: true,
}

export const ICalLightboxType = {
    CREATE: 'create',
    EDIT: 'edit',
    EXPORT: 'export',
}

export const RENDER_LEAVE_TYPES_LIMIT = 6
export const FEEDS_TOOLTIP_EXTRA_CLASS = 'feedsTooltip'
export const ICALENDAR_KEY = 'iCalendar'

export const NO_RIGHT_FOR_RPC_EXCEPTION = 'com.actimind.actitime.services.NoRightsForRemoteCallException'
export const NO_SUCH_ICAL_FEED_SETTINGS_EXCEPTION = 'com.actimind.actiplans.icalendar.NoSuchICalFeedSettingsException'


// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/constants.js